export default "__VITE_ASSET__KwyQmN2C__"